var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Select2',{attrs:{"options":_vm.profiles,"id":_vm.id,"settings":{width: '100%'},"disabled":_vm.isLoading},model:{value:(_vm.value_model),callback:function ($$v) {_vm.value_model=$$v},expression:"value_model"}})
}
var staticRenderFns = []

export { render, staticRenderFns }